import { SmartImage } from "~/components/utils/SmartImage";

export default function NotFoundCourseSection() {
    return (
        <section id="about" className="about">
            <div className="container" data-aos="fade-up">

                <div className="row">
                    <div className="col-lg-6 order-1 order-lg-2" data-aos="fade-left" data-aos-delay="100">
                        <SmartImage
                                            src={'/img/404-error.jpeg'}
                                            alt={'Error'}
                                            className="img-fluid"
                                            widths={[640, 960]}
                                            fit="cover"
                                        />
                        
                    </div>
                    <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content">
                        <h3>Unable to find course</h3>
                        <p className="fst-italic">
                            We are really sorry, but we can&#39;t find the course you are looking for. Please come back later. We have reported this to IT
                        </p>
                    </div>
                </div>

            </div>
        </section>
    );
}